/* eslint-disable */

import React, { useState, useEffect } from "react";
import Popover from "../../components/popover/popover";
// import ReuseableButton from "../Buttons/button";
import FilterListIcon from '@mui/icons-material/FilterList';
import CancelIcon from '@mui/icons-material/Cancel';
import { letterSpacing } from "@mui/system";
import ReuseableButton from "../../components/Buttons/button";
let initialState = {
    testName: "",
    departmentName: "",

}
function PathalogyFilter(props) {
    const { handleFilterClick, fetchLabtest } = props;
    const [filterInputs, setFilterInputs] = useState(initialState)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setFilterInputs(initialState)
        fetchLabtest()
    };
    const handlePatientFilterInputChange = (event) => {
        const { name, value } = event.target;
        setFilterInputs((prevState) => {
            return {
                ...prevState,
                [name]: value,
            };
        });
    }
    const handleClear = () => {
        setFilterInputs(initialState)
        fetchLabtest()
    }

    const content = (
        <div style={{ overflow: "hidden" }}>
            <>

                <div className="container filterContainer">
                    <div className="pt-2" style={{ display: "flex" }}>
                        <span style={{ marginLeft: "auto", cursor: "pointer" }}>
                            <CancelIcon onClick={handleClose} />
                            {/* <img data-test="img-cancel" src={"Cancel"} onClick={handleClose} alt="cancel" /> */}
                        </span>
                    </div>
                    <div style={{ minWidth: "270px" }} className="pt-2 ml-2">
                        <label>Test Name</label>
                        <input
                            id="name"
                            type="text"
                            name="testName"
                            className="form-control input-box"
                            onChange={handlePatientFilterInputChange}
                            value={filterInputs?.testName}
                        />
                    </div>
                    <div style={{ minWidth: "270px" }} className="pt-2 ml-2">
                        <label>Department Name</label>
                        <input
                            id="name"
                            type="text"
                            name="departmentName"
                            className="form-control input-box"
                            onChange={handlePatientFilterInputChange}
                            value={filterInputs?.departmentName}
                        />
                    </div>
                    <div
                        className="pt-2 "
                    >
                        <ReuseableButton
                            text={"Apply"}
                            colorVarient="success"
                            handleChange={(event) => {
                                handleFilterClick(event, filterInputs)
                            }}
                            fullWidthFlag={true}
                        />
                    </div>
                    <div
                    >
                        <ReuseableButton
                            text={"Clear"}
                            colorVarient="clear"
                            className="en-clear"
                            color="#BDBDBD"
                            backgroundColor="#F2F2F2"
                            fullWidthFlag={true}
                            handleChange={handleClear}
                        />
                    </div>
                </div>
            </>

        </div>
    );

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    return (
        <>
            <div className="d-flex justify-content-end mr-4">
                <ReuseableButton
                    text={"filter"}
                    endIcon={<FilterListIcon />}
                    colorVarient="filter"
                    handleChange={handleClick}
                    data-test="open-pop-over"
                />
                {/* <button
                className="btn btn-primary"
                onClick={handleClick}
                data-test="open-pop-over"
            >
                Filter </button> */}
            </div>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                handleClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
                content={content}
            />


        </>
    );
}




export default PathalogyFilter

